(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cloud-cream-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-waitlist-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var area = btn.parentElement.querySelector('[data-waitlist-form]');
        if (!area) return;
        area.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        btn.style.display = 'none';
        var input = area.querySelector('input[type="email"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloud-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cloud-hero]').forEach(function (section) {
      var slides = section.querySelectorAll('[data-slide]');
      if (slides.length < 2) return;
      var speed = parseFloat(section.getAttribute('data-rotation-speed')) || 5;
      var current = 0;
      var timer = null;
      var hasManuallyNavigated = false;

      var dots = section.querySelectorAll('[data-hero-dot]');

      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          var active = idx === current;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === current);
        });
      }
      function startCycle() {
        stopCycle();
        timer = setInterval(function () { show(current + 1); }, speed * 1000);
      }
      function stopCycle() { if (timer) { clearInterval(timer); timer = null; } }

      var media = section.querySelector('[data-hero-slides]');
      var isTouchDevice = window.matchMedia('(hover: none)').matches;
      if (media && !isTouchDevice) {
        media.addEventListener('mouseenter', function () {
          if (!hasManuallyNavigated) {
            show(1);
            startCycle();
          }
        });
        media.addEventListener('mouseleave', function () {
          stopCycle();
          if (!hasManuallyNavigated) {
            show(0);
          }
        });
      }

      dots.forEach(function (d, idx) {
        d.addEventListener('click', function (e) {
          e.stopPropagation();
          hasManuallyNavigated = true;
          stopCycle();
          show(idx);
        });
      });

      if (media) {
        var startX = 0, startY = 0;
        var tracking = false;
        var SWIPE_THRESHOLD = 25;

        function swipeStart(x, y) { startX = x; startY = y; tracking = true; }
        function swipeEnd(x, y) {
          if (!tracking) return;
          tracking = false;
          var dx = x - startX;
          var dy = y - startY;
          if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
          hasManuallyNavigated = true;
          stopCycle();
          show(current + (dx < 0 ? 1 : -1));
        }

        if (window.PointerEvent) {
          media.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'mouse') return;
            swipeStart(e.clientX, e.clientY);
          });
          media.addEventListener('pointerup', function (e) {
            if (e.pointerType === 'mouse') return;
            swipeEnd(e.clientX, e.clientY);
          });
          media.addEventListener('pointercancel', function () { tracking = false; });
        }

        media.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          swipeStart(e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: true });
        media.addEventListener('touchend', function (e) {
          var t = e.changedTouches[0];
          if (!t) return;
          swipeEnd(t.clientX, t.clientY);
        }, { passive: true });
        media.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
      }

      // Default: slide 1 (jar) — no auto-rotation until hover
      show(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-quotes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ss-community-section').forEach(function (section) {
      var carousel = section.querySelector('[data-community-carousel]');
      if (!carousel) return;
      var slides = section.querySelectorAll('[data-carousel-slide]');
      var dots = section.querySelectorAll('[data-carousel-dot]');
      var prev = section.querySelector('[data-carousel-prev]');
      var next = section.querySelector('[data-carousel-next]');
      var speed = parseInt(section.getAttribute('data-autoplay'), 10) || 6;
      var current = 0;
      var timer = null;

      if (slides.length === 0) return;

      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          var active = idx === current;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === current);
        });
      }
      function start() {
        stop();
        if (slides.length < 2) return;
        timer = setInterval(function () { show(current + 1); }, speed * 1000);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (prev) prev.addEventListener('click', function () { show(current - 1); start(); });
      if (next) next.addEventListener('click', function () { show(current + 1); start(); });
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { show(idx); start(); }); });
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return String(n).padStart(2, '0'); }
    function tickAll() {
      var grids = document.querySelectorAll('.ss-countdown-grid');
      grids.forEach(function (grid) {
        var iso = grid.getAttribute('data-launch');
        if (!iso) return;
        var target = new Date(iso).getTime();
        var diff = Math.max(0, target - Date.now());
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff / 3600000) % 24);
        var mins = Math.floor((diff / 60000) % 60);
        var secs = Math.floor((diff / 1000) % 60);
        var setUnit = function (unit, val) {
          var el = grid.querySelector('[data-unit="' + unit + '"]');
          if (el) el.textContent = pad(val);
        };
        setUnit('days', days);
        setUnit('hours', hours);
        setUnit('mins', mins);
        setUnit('secs', secs);
      });
    }
    tickAll();
    setInterval(tickAll, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-formula-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = btn.closest('.ss-formula-section') || btn.closest('section');
        if (!section) return;
        var extras = section.querySelector('[data-formula-extras]');
        var collapsedLabel = section.querySelector('[data-toggle-label-collapsed]');
        var expandedLabel = section.querySelector('[data-toggle-label-expanded]');
        if (!extras) return;
        var isExpanded = btn.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          extras.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
          if (collapsedLabel) collapsedLabel.hidden = false;
          if (expandedLabel) expandedLabel.hidden = true;
        } else {
          extras.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          if (collapsedLabel) collapsedLabel.hidden = true;
          if (expandedLabel) expandedLabel.hidden = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soft-place"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ss-soft-place-section').forEach(function (section) {
      var toggle = section.querySelector('[data-circle-toggle]');
      var formArea = section.querySelector('[data-circle-form]');
      if (!toggle || !formArea) return;
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          formArea.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          formArea.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          var input = formArea.querySelector('input[type="email"]');
          if (input) setTimeout(function () { input.focus(); }, 50);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
